import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Spin } from "antd";
import { useHistory } from "react-router-dom";

import Questions from "../../../components/form/question/questions";
import MainVotingInfo from "../../../components/form/main-voting-info/main-voting-info";
import FormButtons from "../../../components/form/form-buttons/form-buttons";
import useSavedValuesFromBackend from "../../../hooks/useSavedValuesFromBackend";
import editVoting from "../../../store/thunks/edit-voting";
import deleteVoting from "../../../store/thunks/deleteVoting";
import { startVoting } from "../../../store/thunks/voting-states";
import { mergeDeep } from "../../../../../helpers/merge-deep";

const EditingVoting = (props) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const { voting, form, height, allValues } = props;
	const { getFieldsValue, setFieldsValue, getFieldDecorator } = form;
	const styleContainer = {
		height: height,
		overflowY: "auto",
		overflowX: "hidden",
		textAlign: "center",
		alignItems: "center",
		borderRight: "1px solid",
		borderColor: "#efefef",
	};

	useSavedValuesFromBackend(setFieldsValue, getFieldDecorator);

	const onCancel = useCallback(() => {
		history.push(`/Voting/${voting.id}`);
	}, [voting.id]);
	const onSave = useCallback(async () => {
		await dispatch(editVoting(getFieldsValue()));
		history.push(`/Voting/${voting.id}`);
	}, [voting.id]);
	const onPlay = useCallback(async () => {
		await dispatch(editVoting(getFieldsValue()));
		await dispatch(startVoting({ ...getFieldsValue(), id: voting.id }));
		history.push(`/Voting/${voting.id}`);
	}, [voting.id]);
	const onDelete = useCallback(async () => {
		await dispatch(deleteVoting(voting.id));
		history.push(`/Voting`);
	}, [voting.id]);

	const memoizedForm = useMemo(() => props.form, []);

	if (!voting) {
		return (
			<Spin>
				<div />
			</Spin>
		);
	}
	const buttonsProps = {
		formValues: allValues,
		editing: voting.id,
		onCancel,
		onPlay,
		onSave,
		onDelete,
	};

	return (
		<div style={styleContainer} className="NewVoting">
			<FormButtons {...buttonsProps} />
			<Form layout="vertical">
				<MainVotingInfo
					form={memoizedForm}
					votingId={voting.id}
					title={allValues.title}
					description={allValues.description}
					period={allValues.period}
					file={allValues.file}
					addresses={allValues.addresses}
				/>
				<Questions
					form={memoizedForm}
					questions={allValues.questions}
					questionsKeys={allValues.questionsKeys}
				/>
			</Form>
			<FormButtons bottom {...buttonsProps} />
		</div>
	);
};

const EditingVotingForm = (props) => {
	const [allValues, setAllValues] = useState({});
	const FormComponent = useMemo(
		() =>
			Form.create({
				onValuesChange: (_props, changedValues, newAllValues) => {
					const ableToMerge = !Object.keys(changedValues).some(
						(key) => key.includes(".") || key.includes("[")
					);
					setAllValues((allValues) => {
						if (ableToMerge) {
							return mergeDeep(allValues, changedValues, {
								ignoreKeys: ["file"],
							});
						} else {
							return { ...newAllValues };
						}
					});
				},
			})(EditingVoting),
		[]
	);
	return <FormComponent {...props} allValues={allValues} />;
};
export default EditingVotingForm;
